import { useMemo } from 'react'
import { useGridSize } from '../useGridSize'

import { Icon, IconButton } from '@lounge-fe/ui-kit'
import classNames from 'classnames'
import { gridSize } from '../types'
import { t } from 'i18next'

export const GridSizeSelector = () => {
  const { currentGridSize, setCurrentGridSize } = useGridSize()

  const handleGridChange = (size: gridSize) => setCurrentGridSize(size)
  const handleLargeGrid = () => handleGridChange('lg')
  const handleMediumGrid = () => handleGridChange('md')
  const handleSmallGrid = () => handleGridChange('sm')

  const selectedStyles = {
    lg: currentGridSize === 'lg',
    md: currentGridSize === 'md',
    sm: currentGridSize === 'sm',
  }

  return (
    <div className="inline-flex items-center gap-2">
      <IconButton
        type="button"
        aria-label={t('action.view_grid_in_large')}
        icon={
          <Icon.GridLarge
            underline={selectedStyles.lg}
            fill="none"
            stroke={selectedStyles.lg ? 'currentColor' : '#888888'}
            className={classNames('w-4', selectedStyles.lg ? 'h-5' : 'h-4')}
          />
        }
        onClick={handleLargeGrid}
      />
      <IconButton
        type="button"
        aria-label={t('action.view_grid_in_medium')}
        icon={
          <Icon.GridMedium
            underline={selectedStyles.md}
            fill="none"
            stroke={selectedStyles.md ? 'currentColor' : '#888888'}
            className={classNames('w-4', selectedStyles.md ? 'h-5' : 'h-4')}
          />
        }
        onClick={handleMediumGrid}
      />
      <IconButton
        type="button"
        aria-label={t('action.view_grid_in_small')}
        icon={
          <Icon.GridSmall
            underline={selectedStyles.sm}
            fill="none"
            stroke={selectedStyles.sm ? 'currentColor' : '#888888'}
            className={classNames('w-4', selectedStyles.sm ? 'h-5' : 'h-4')}
          />
        }
        onClick={handleSmallGrid}
      />
    </div>
  )
}
